/** How often an unsettled homework upload or page asks the server again (#376). */
export const POLL_INTERVAL_MS = 3000;
